import React from 'react';
import { useNavigate } from 'react-router-dom';

const HelpSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="py-12 bg-blue-600 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">
            Need Help Getting Started?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Our support team is here to help you make the most of your landlord
            toolkit.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/contact')}
              className="px-8 py-3 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all"
            >
              Contact Support
            </button>
            <button
              onClick={() => navigate('/landlord-toolkit/docs')}
              className="px-8 py-3 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-all"
            >
              View Documentation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HelpSection;
